module.exports = __webpack_public_path__ + "img/plumber02.001d86e3.jpg";